import Vue from 'vue'
import Vuex from 'vuex'
import actions from '../actions'
import mutations from '../mutations'
Vue.use(Vuex)

const state = {
  searchResults: [],
  total: 0,
  searchTearm: '',
  nextLink: 1,
  offset: 0,
  searchType: 'album',
  noResults: false,
  limit: 20,
  tracks: [],
  bio: [],
  similarArtist: [],
  bioContent: '',
  bioImg: ''
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/data/store.js